import React from 'react';
import LevelLogo from './level-logo.svg';

// Collapsed sidebar: constrain by width so the wordmark fits the narrow rail.
const LogoIcon = () => {
  return <img src={LevelLogo} alt="LEVEL" style={{ width: 40, height: 'auto' }} />;
};

export default LogoIcon;
